import { PropsWithChildren } from 'react';

import LoadingCircle from '~components/Loading';
import useMedia from '~hooks/useMedia';

export default function RenderOnClientReady({ children }: PropsWithChildren) {
  const { isReady } = useMedia();

  if (!isReady) {
    return <LoadingCircle />;
  }

  return <>{children}</>;
}
